import React from 'react'
import { useViewport } from '../../utils'
import Filters from './list-filter-filters'
import ListFilterHeader from './list-filter-header'

const ListFilter = ({
  // Pagination Info Props
  pageIndexes = [0, 10],
  totalData = 0,

  // Sorter Props
  sortOptions = [],
  onSort = () => {},

  // Filters Props
  query = {},
  setStatus,
  filtersOnly = false
}) => {
  const { isDesktop } = useViewport()

  return (
    <div>
      {
        (isDesktop && !filtersOnly) &&
        <ListFilterHeader
          pageIndexes={pageIndexes}
          totalData={totalData}
          query={query}
          sortOptions={sortOptions}
          onSort={onSort}
        />
      }
      <Filters
        query={query}
        setStatus={setStatus}
      />
    </div>
  )
}

export { ListFilter }
